import React from 'react';
import { Dropdown, Form as SemForm } from 'semantic-ui-react';
import moment from 'moment';

const errorStyle = {
	marginBottom: 10,
	color: '#dc0000',
	fontSize: '0.7em'
};

const label = {
	fontSize: '1em',
	fontWeight: 600,
	marginTop: 5,
	marginLeft: 2,
	marginBottom: 10,
    width: '90%'
};

const labelFreeInput = {
	fontSize: '0.8em',
	marginTop: 5,
	marginLeft: 2,
    width: '90%'
};

const styles = {
	select: {
		width: '30%',
		height: 38,
		border: '1px solid rgba(34,36,38,.15)',
		transition: 'box-shadow .1s ease,border-color .1s ease',
		background: 'transparent',
		fontSize: '0.9em',
		':focus': {
			border: '1px solid #85b7d9',
			outline: 'none'
		},
		':active': {
			outline: 'none',
			border: '1px solid #85b7d9'
		}
	},
	inputStyle: {
		width: '100%'
	},
	inputStyleFreeInput: {
		height: 30,
		backgroundColor: 'transparent'
	},
	inputContainer: {
		width: '100%',
		display: 'flex',
		alignItems: 'center'
	},
	records: {
		position: 'absolute',
		right: 0
	},
	crossRequired: {
		color: '#c5190e',
		fontSize: '1em',
		position: 'relative',
		bottom: 4,
		left: 4
	}
};

const Records = ({ records, onClick, disabled }) => (
	<Dropdown
		closeOnEscape
		closeOnChange
		icon='file alternate outline'
		direction='right'
		className='largegreenIcon'
		style={styles.records}
		disabled={disabled}
	>
		<Dropdown.Menu direction='left'>
			<Dropdown.Header icon='folder outline' content='Antécédants' />
			<Dropdown.Divider />
			{records.map((r, i) => (
				<Dropdown.Item
					key={r.label + ' ' + r.value + i}
					description={moment(r.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
					onClick={e => {
						if (e !== undefined) e.preventDefault();
						onClick(r.value);
					}}
					text={String(r.label)}
				/>
			))}
		</Dropdown.Menu>
	</Dropdown>
);

const CustomInputTextComponentWithRecords = ({
	field,
	form: { touched, errors },
	records,
	setfieldvalue,
	disabled,
	prevalidFolders,
	...props
}) => (
	<div>
		<div style={props.freeInput !== undefined ? labelFreeInput : label}>
			{props.customlabel}
			{props.required && <span style={styles.crossRequired}>*</span>}
			{records.length > 0 && (
				<Records
					records={records}
					onClick={value => {
						setfieldvalue(field.name, value);
					}}
					disabled={disabled}
				/>
			)}
		</div>
		<div style={styles.inputContainer}>
			<SemForm.Input
				{...field}
				{...props}
				prevalidfolders={prevalidFolders}
				fluid
				error={errors[field.name]}
				placeholder={props.placeholder}
				style={
					props.freeInput !== undefined
						? styles.inputStyleFreeInput
						: styles.inputStyle
				}
			/>
		</div>

		{touched[field.name] && errors[field.name] && (
			<div style={errorStyle}>{errors[field.name]}</div>
		)}
	</div>
);

export default CustomInputTextComponentWithRecords;
